import React from 'react';
import Card from 'react-bootstrap/esm/Card';

const ReportCard = ({ title, children, renderLoadingIcon=()=>{ return <></> }, ...props }) => {

  return <div {...props}>
    <Card >
      <Card.Header>
        {title}
        {renderLoadingIcon()}
        </Card.Header>
      <Card.Body>
        {children}
      </Card.Body>
    </Card>
  </div>
};

export default ReportCard;
